import React from 'react';

import s from './index.module.css';
import { IWrapperProps } from './types';

function Wrapper({ children, innerRef, headlineFontSize, additionalLineHeight }: IWrapperProps) {
  return (
    <div
      className={`${s.headline} custom-headline`}
      ref={innerRef}
      lang="en"
      style={{ fontSize: `${headlineFontSize}px`, lineHeight: `${headlineFontSize + additionalLineHeight}px` }}
      data-block
    >
      {children}
    </div>
  );
}

export default Wrapper;
